<template>
<div class="service-content">
  <div class="content">
    <div class="title-name">汽车金融解决专题</div>
    <div class="title-sub">概述</div>
    <div class="text">
      09年以来，随着汽车销售市场的回暖，国内汽车金融业务步入快速增长期。在国外，汽车金融公司早已在多年的市场考验中成熟壮大。 目前，全球41个国家有38.2%的用户是通过贷款买车，尤其在整车利润日趋微薄的今天，汽车金融公司成为了汽车公司利润来源的一块宝藏。汽车金融公司所提供的利润能够占整个汽车集团利润的1/3以上。 2015年中国汽车销量突破2500万辆，占全球汽车销量的将近30%，标志着我国正式进入汽车消费大国。我国汽车消费信贷渗透率仅为25%左右。业内预测，2016年底时，汽车消费金融市场金额将达到7700亿元，汽车金融市场吸引了各类企业纷纷涉足，从车企、银行、保险公司到专业的汽车金融公司等。
    </div>
    <div class="title-sub">解决方案</div>
    <div class="text">
      基于橡诺科技对汽车金融行业的了解，相关行业服务包括：<br>
      针对于汽车联合贷款平台产品的服务；<br>
      针对汽车联合贷款业务咨询的服务；<br>
      针对汽车金融行业的移动互联的相关服务；<br>
      橡诺根据不同的服务需求，严格遵循相关服务流程，在每个关键节点对服务成果进行监控，并持续进行修正，最终让客户满意。
    </div>
    <div class="title-sub">能力优势</div>
    <div class="text">
      多年的行业服务经验；<br>
      针对于汽车联合贷款平台对年的研发、测试、运维的经验；<br>
      汽车金融行业的移动互联项目的实施经验；<br>
      针对汽车金融公司业务，进行定制化研发与实施，对正在运作的相关项目提供专业化的项目运维、二次开发与实施；<br>
      针对汽车联合贷款业务咨询服务。
    </div>
    <div class="title-sub">客户收益</div>
    <div class="text">
      定制化的汽车行业服务方案，满足客户的多样服务需求；<br>
      不断完善服务模型，能为客户提供高品质、高效的服务；<br>
      帮助客户实现对市场的准确定位及精准服务；<br>
      帮助客户更好地预测及分析行业动态，及时有效的调整企业发展战略。
    </div>
    <div class="title-sub">典型客户</div>
    <div class="text">
      某汽车金融公司<br>
      某汽车贷款管理咨询公司<br>
      某全球汽车企业中国合资公司
    </div>
  </div>
  <Mission/>
</div>
</template>

<script>
import Mission from '@/components/Mission'
export default {
  name: '',
  components: {
    Mission
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      // align-items: center;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        // background-color: #eee;
        // padding: 10px;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
      }
    }
}
</style>
